import PropTypes from 'prop-types'
import React from 'react'
import styles from './nav.module.scss'
import TopLevel from 'components/Nav/subcomponents/TopLevel'
import SubLevel from 'components/Nav/subcomponents/SubLevel'

const Nav = ({ items = [], level = 1 }) => {
  return (
    <div className={styles['nav']}>
      <nav className={styles['nav__list']}>
        {items.map((props) => {
          //eslint-disable-next-line
          const { label_key, routes = [], key } = props
          if (!label_key) return

          return level === 1 && routes.length > 0 ? (
            <TopLevel {...props} level={level} routeKey={key} />
          ) : (
            <SubLevel {...props} level={level} routeKey={key} />
          )
        })}
      </nav>
    </div>
  )
}

Nav.propTypes = {
  items: PropTypes.array,
  simple: PropTypes.bool,
  open: PropTypes.bool,
  level: PropTypes.number,
}

export default Nav
